module.exports = __webpack_public_path__ + "static/media/visa_logo.2184a781.svg";